export const enGb = {
  menuBar: {
    file: {
      newFile: 'New Pattern',
      savePNG: 'Save as PNG',
      saveJPG: 'Save as JPG',
      saveProject: 'Save Project',
      openProject: 'Open Project',
      unsavedChangesWarning: 'You have unsaved changes. Are you sure you want to create a new pattern?'
    },
    display: {
      showGuides: 'Show Guides'
    },
    donate: 'Support this project',
    undo: 'Undo',
    redo: 'Redo'
  },
  newProject: {
    title: 'New Pattern',
    settings: {
      wedges: 'Number of Wedges',
      rows: 'Number of Rows',
      circleStep: 'Circle Step',
      radialStep: 'Radial Lines Step',
      stitchScale: 'Stitch Scale'
    },
    buttons: {
      create: 'Create',
      cancel: 'Cancel'
    }
  },
  stitchTypes: {
    title: 'Stitch Types',
    color: 'Stitch Colour',
    'single': 'Double Crochet',
    'double': 'Treble',
    'treble': 'Double Treble',
    'chain': 'Chain',
    'slip': 'Slip Stitch',
    'half-double': 'Half Treble',
    'magic-ring': 'Magic Ring',
    'picot': 'Picot',
    'double-treble': 'Triple Treble',
    'triple-treble': 'Quadruple Treble',
    'front-post-dc': 'Raised Treble Front',
    'back-post-dc': 'Raised Treble Back'
  },
  help: {
    title: 'User Guide',
    close: 'Close',
    basics: {
      title: 'Basic Usage',
      content: 'Doily.app is an editor for creating circular crochet patterns. Select a stitch type and color from the right panel, then click on the canvas to place stitches. You can drag placed stitches to reposition them. Click a stitch to select it, press Delete to remove it, or Escape to deselect.'
    },
    stitches: {
      title: 'Stitches and Placement',
      content: 'The right panel offers over 40 stitch variants organized in five categories: basic stitches (chain, slip, single, half-double, double, treble, double treble, triple treble, picot, puffs, clusters), increases, decreases, misc (magic ring, front/back loop, front/back post DC), and markers (numbered and directional). Many stitches have variant options — click the small dropdown arrow below a stitch to switch between them. Hover over the canvas to see a placement preview, then click to place. Use Ctrl+Z (Cmd+Z on Mac) to undo and Ctrl+Shift+Z to redo.'
    },
    orientation: {
      title: 'Orientation Center',
      content: 'The orientation crosshair determines the direction stitches face — they automatically rotate to point toward it. Ctrl+click (Cmd+click on Mac) anywhere on the canvas to move it. Double-click the orientation center to reset it to the pattern center.'
    },
    symmetry: {
      title: 'Radial Symmetry',
      content: 'Use the Symmetry dropdown in the top toolbar to enable radial symmetry (2 to 36 axes). When active, every stitch you place is automatically duplicated around the center. Ghost previews show where copies will appear. Hold Shift while placing to temporarily skip symmetry for a single stitch. You can delete or drag individual copies independently.'
    },
    guides: {
      title: 'Guide Lines',
      content: 'Guides help with precise stitch placement. Toggle them with the "Show Guides" checkbox in the top toolbar. The grid shows radial lines and concentric circles based on your project settings. When symmetry is active, dashed blue lines show the symmetry axes. Guide visibility also affects exported images.'
    },
    colors: {
      title: 'Working with Colors',
      content: 'Choose a stitch color from the 40-color palette in the right panel. Hover over a swatch to see its hex code. All newly placed stitches use the selected color. To change an existing stitch\'s color, select the Recolor tool (paint bucket icon in the toolbar), then click or drag over stitches to repaint them.'
    },
    saving: {
      title: 'Saving Your Pattern',
      content: 'Your pattern is automatically saved in the browser as you work. Use the file menu to: create a new pattern, save as PNG or JPG (the exported image includes a legend of all stitch types used), export an editable .doilyapp project file you can share or back up, or open a previously saved project.'
    },
    tools: {
      title: 'Eraser and Recolor Tools',
      content: 'The toolbar includes an Eraser (X icon) and a Recolor tool (paint bucket). Click the tool icon to activate it, then click or drag across stitches on the canvas. The Eraser removes stitches, and the Recolor tool changes them to the currently selected color. Click the tool icon again to deactivate it.'
    }
  },
  stitchesPanel: {
    symmetry: 'Symmetry',
    symmetryOff: 'Off',
    eraser: 'Eraser',
    recolor: 'Change Color',
    group_stitch: 'Stitches', group_increase: 'Increases', group_decrease: 'Decreases', group_misc: 'Misc', group_marker: 'Markers',
  },
  copyright: {
    text: '© {year} Created by Julie N. using',
    cursor: 'Cursor'
  },
  legend: {
    signature: 'Made with doily.app.craftodejnice.cz'
  }
}; 